import request from "@/utils/request";

export function getGrcMetadata(resource, params) {
  return request({
    url: `/grc-metadata/${resource}`,
    method: "get",
    params,
  });
}

export function getGrcMetadataItem(resource, id, params) {
  return request({
    url: `/grc-metadata/${resource}/${id}`,
    method: "get",
    params,
  });
}

export function createGrcMetadata(resource, data) {
  return request({
    url: `/grc-metadata/${resource}`,
    method: "post",
    data,
  });
}

export function updateGrcMetadata(resource, id, data) {
  return request({
    url: `/grc-metadata/${resource}/${id}`,
    method: "put",
    data,
  });
}

export function deleteGrcMetadata(resource, id) {
  return request({
    url: `/grc-metadata/${resource}/${id}`,
    method: "delete",
  });
}
